import React, { ReactNode } from "react";
import { MiniChart } from "./MiniChart";

export type Props = {
  data: { date: string | Date | number; value: number }[];
  icon: ReactNode;
  title: string;
  subtitle?: string;
  headline: string;
  percent?: number;
  percentPrefix?: string;
  onClick?: () => void;
  height?: string;
};

export const MiniCardChart = ({ data, onClick, height, ...rest }: Props) => (
  <MiniChart onClick={onClick} data={data} height={height} {...rest} />
);
